import clsx from 'clsx'
import pluralize from 'pluralize'

import { DelimitedContent, FvLinkButton } from '@fv/client-components'
import type { FullShipment, PropsWithClassName, Quote } from '@fv/client-types'
import { formatMoney } from '@fv/models/core'

import { DividedContent } from '@/components/DividedContent'
import { ShipperTooltip } from '@/components/ShipperTooltip'
import { routes } from '@/routes'
import { mapPaymentTerms } from '@/utils/shipmentFuncs'

import { HasPermission } from '../auth'
import { quoteFuncs } from '../quote/quoteFuncs'

const TransitDays = ({ load, quote }: { load: FullShipment; quote: Quote }) => {
  const daysText = `${quote.transitDaysMin} ${pluralize(
    'day',
    quote.transitDaysMin,
  )}`
  return (
    <ShipperTooltip
      label={`ETA ${quoteFuncs
        .getEstimatedDeliveryDate(load.pickupDate, quote)
        ?.format('MM-DD-YYYY')}`}
    >
      <span className="decoration-fv-blue ml-0 underline">{daysText}</span>
    </ShipperTooltip>
  )
}
type Props = PropsWithClassName<{
  load?: FullShipment
  quote: Quote
}>
export const BookingRateDetails = ({ load, quote, className }: Props) => {
  const paymentTerms = mapPaymentTerms({ selectedQuote: quote })
  const transitDays = load && quote.transitDaysMin && (
    <TransitDays load={load} quote={quote} />
  )
  return (
    <DividedContent
      theme="beer"
      className={clsx(
        'border-b border-[#e8e0b2] bg-fv-beer-light px-6 py-4',
        className,
      )}
    >
      <p className="mb-0">
        <DelimitedContent delimiter={<> / </>}>
          {quote.assetCarrierName ?? quote.providerName}
          {quote.serviceDescription && <> {quote.serviceDescription} </>}
          <HasPermission name="view-rates">
            {formatMoney(quote.amount, quote.currency)}{' '}
            {quote.paymentTerms && paymentTerms}
          </HasPermission>
          {transitDays && transitDays}
          {!!quote.quoteNum && <>Quote # {quote.quoteNum}</>}
        </DelimitedContent>
      </p>
      {!!load && (
        <FvLinkButton icon="list" to={routes.rates(load)}>
          View other rates
        </FvLinkButton>
      )}
    </DividedContent>
  )
}
